import { render, staticRenderFns } from "./AreaCode.vue?vue&type=template&id=eb7e827c&"
import script from "./AreaCode.vue?vue&type=script&lang=js&"
export * from "./AreaCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports